export default __webpack_public_path__ + "static/media/promptPay1.16db91f6.png";